var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/Renderer.tsx
import * as React2 from "react";

// src/Terminal.tsx
import * as React from "react";
import classNames from "classnames";
var cursor = /* @__PURE__ */ React.createElement("span", {
  className: "Terminal-cursor"
});
var prompt = (prefix) => /* @__PURE__ */ React.createElement("span", {
  className: "Terminal-prompt"
}, prefix || "$", " ");
var renderLines = (lines) => {
  return lines.map((line) => {
    return /* @__PURE__ */ React.createElement(React.Fragment, {
      key: line.id
    }, line.cmd ? prompt(line.prompt) : "", line.element ? line.element : line.text ? /* @__PURE__ */ React.createElement("span", {
      style: { color: line.color }
    }, line.text) : line.text, line.current && line.cmd ? cursor : "", /* @__PURE__ */ React.createElement("br", null));
  });
};
var getWindowStyle = (white) => {
  return classNames({
    "Terminal-window": true,
    "Terminal-window-white": white
  });
};
var getTerminalStyle = (code) => {
  return classNames({
    "Terminal-term": true,
    "Terminal-term-code": code
  });
};
var getButtonStyle = (type) => {
  return classNames({
    "Terminal-btn": true,
    "Terminal-btn-close": type === "close",
    "Terminal-btn-minimize": type === "minimize",
    "Terminal-btn-maximize": type === "maximize"
  });
};
var getBodyStyle = (code) => {
  return classNames({
    "Terminal-body": true,
    "Terminal-body-animated": !code
  });
};
var getConsoleStyle = (code, white) => {
  return classNames({
    "Terminal-console": true,
    "Terminal-console-code": code,
    "Terminal-console-white": white
  });
};
var Terminal = ({
  children,
  white,
  height,
  code,
  onReplay,
  completed,
  replay = true
}) => {
  const btnClassName = white ? "Terminal-control-btn Terminal-control-btn-white" : "Terminal-control-btn";
  return /* @__PURE__ */ React.createElement("div", {
    className: getWindowStyle(white)
  }, /* @__PURE__ */ React.createElement("div", {
    className: getTerminalStyle(code),
    style: height ? { height } : null
  }, /* @__PURE__ */ React.createElement("div", {
    className: "Terminal-header"
  }, /* @__PURE__ */ React.createElement("span", {
    className: getButtonStyle("close")
  }), /* @__PURE__ */ React.createElement("span", {
    className: getButtonStyle("minimize")
  }), /* @__PURE__ */ React.createElement("span", {
    className: getButtonStyle("maximize")
  })), /* @__PURE__ */ React.createElement("div", {
    className: getBodyStyle(code)
  }, /* @__PURE__ */ React.createElement("div", {
    className: getConsoleStyle(code, white)
  }, code ? /* @__PURE__ */ React.createElement("code", {
    className: "Terminal-code"
  }, children) : /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", {
    className: "Terminal-code"
  }, renderLines(children)), completed && replay ? /* @__PURE__ */ React.createElement("a", {
    className: btnClassName,
    onClick: () => onReplay()
  }, "Replay") : null)))));
};
var Terminal_default = Terminal;

// src/contentHandler.ts
var terminalContent = function* (lines) {
  if (lines.length === 0) {
    return [];
  }
  let lineIndex = 0;
  let linePosition = 0;
  let cmdTimer = null;
  let frameIndex = 0;
  let frameTimer = null;
  let frameRepeatCounter = 0;
  const buffer = [];
  while (true) {
    if (lineIndex < lines.length) {
      if (!lines[lineIndex].cmd) {
        const frames = lines[lineIndex].frames;
        if (!frames) {
          buffer.push({
            id: lineIndex,
            text: lines[lineIndex].text,
            element: lines[lineIndex].element,
            cmd: false,
            current: false,
            color: lines[lineIndex].color
          });
          yield buffer;
          linePosition = 0;
          lineIndex++;
        } else if (frameIndex < frames.length) {
          if (frameIndex === 0) {
            if (!frameTimer && frameRepeatCounter === 0) {
              buffer.push({
                id: lineIndex,
                text: frames[0].text,
                element: frames[0].element,
                cmd: false,
                current: true,
                color: lines[lineIndex].color
              });
            }
          }
          buffer[lineIndex].text = frames[frameIndex].text;
          buffer[lineIndex].element = frames[frameIndex].element;
          if (frameTimer == null) {
            if (!isNaN(frames[frameIndex].delay)) {
              frameTimer = setTimeout(() => {
                clearTimeout(frameTimer);
                frameTimer = null;
                frameIndex++;
              }, frames[frameIndex].delay);
              yield buffer;
            } else {
              frameIndex++;
            }
          }
        } else {
          const { repeat, repeatCount } = lines[lineIndex];
          if (repeat && frameRepeatCounter <= repeatCount) {
            frameRepeatCounter++;
            frameIndex = 0;
          } else {
            if (lines[lineIndex].text) {
              buffer[lineIndex].text = lines[lineIndex].text;
            }
            if (lines[lineIndex].element) {
              buffer[lineIndex].element = lines[lineIndex].element;
            }
            buffer[lineIndex].current = false;
            linePosition = 0;
            frameIndex = 0;
            frameRepeatCounter = 0;
            lineIndex++;
          }
        }
      } else if (linePosition > lines[lineIndex].text.length) {
        buffer[lineIndex].current = lineIndex === lines.length - 1;
        linePosition = 0;
        lineIndex++;
      } else {
        if (linePosition === 0 && !cmdTimer) {
          buffer.push({
            id: lineIndex,
            text: "",
            element: lines[lineIndex].element,
            cmd: lines[lineIndex].cmd,
            prompt: lines[lineIndex].prompt,
            color: lines[lineIndex].color,
            current: true
          });
        }
        buffer[lineIndex].text = lines[lineIndex].text.substring(0, linePosition);
        if (cmdTimer == null) {
          const delay = lines[lineIndex].delay;
          if (!isNaN(delay)) {
            cmdTimer = setTimeout(() => {
              clearTimeout(cmdTimer);
              cmdTimer = null;
              linePosition++;
            }, delay);
          } else {
            linePosition++;
          }
        }
      }
      yield buffer;
    } else {
      return buffer;
    }
  }
};
var contentHandler_default = terminalContent;

// src/Renderer.tsx
var Renderer = React2.forwardRef((_a, ref) => {
  var _b = _a, { lines: initialLines = [], interval = 100, onCompleted } = _b, rest = __objRest(_b, ["lines", "interval", "onCompleted"]);
  const [lines, setLines] = React2.useState([]);
  const [completed, setCompleted] = React2.useState(false);
  let intervalRef = React2.useRef();
  let contentRef = React2.useRef();
  React2.useEffect(() => {
    contentRef.current = contentHandler_default(initialLines);
    intervalRef.current = setInterval(() => {
      const { value, done } = contentRef.current.next();
      if (value) {
        setLines([...lines, ...value]);
      }
      if (done) {
        clearTimeout(intervalRef.current);
        setCompleted(true);
      }
    }, interval);
    return () => clearTimeout(intervalRef.current);
  }, []);
  const replay = () => {
    contentRef.current = contentHandler_default(initialLines);
    setCompleted(false);
    intervalRef.current = setInterval(() => {
      if (contentRef.current) {
        const { value, done } = contentRef.current.next();
        setLines([...value]);
        if (done) {
          clearInterval(intervalRef.current);
          setCompleted(true);
        }
      }
    }, interval);
  };
  React2.useImperativeHandle(ref, () => ({
    replay
  }));
  React2.useEffect(() => {
    if (completed && typeof onCompleted !== "undefined") {
      onCompleted(replay);
    }
  }, [completed]);
  return /* @__PURE__ */ React2.createElement(Terminal_default, __spreadProps(__spreadValues({}, rest), {
    onReplay: () => replay(),
    completed
  }), lines);
});
var Renderer_default = Renderer;

// src/Code.tsx
import * as React3 from "react";
var Code = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React3.createElement(Terminal_default, __spreadProps(__spreadValues({}, rest), {
    code: true
  }), children);
};
var Code_default = Code;

// src/index.ts
var src_default = Renderer_default;
export {
  Code_default as Code,
  src_default as default
};
